module.exports = __webpack_public_path__ + "resources/img/career-welfareImg9.e14493b2.jpg";